import { render, staticRenderFns } from "./queryGather.vue?vue&type=template&id=a4a61e2a&scoped=true&"
import script from "./queryGather.vue?vue&type=script&lang=js&"
export * from "./queryGather.vue?vue&type=script&lang=js&"
import style0 from "./queryGather.vue?vue&type=style&index=0&id=a4a61e2a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4a61e2a",
  null
  
)

export default component.exports